
import { trackDownloadsAsProperty, trackDownloadedProduct } from 'lib/Segment/customTrackers';
import _ from 'lodash';
import {
	CAP_KEY,
	USER_DOWNLOAD_NOTIFICATION_SETTING_KEY,
	DESKTOP_APPS
} from '../config';

export const trackAndDownload = (props, downloadUrl, storageKey, trackingKey, options) => {
	const downloadNotificationSettings = _.get(props.settings,
		`${CAP_KEY}.${USER_DOWNLOAD_NOTIFICATION_SETTING_KEY}`, {});
	const companySettings = downloadNotificationSettings[props.company.id] || {};

	companySettings[storageKey] || (companySettings[storageKey] = []);

	companySettings[storageKey].push({ date: new Date() });
	downloadNotificationSettings[props.company.id] = companySettings;

	props.writeUserSettings({
		[USER_DOWNLOAD_NOTIFICATION_SETTING_KEY]: downloadNotificationSettings
	});

	const newWindow = window.open(downloadUrl, '_blank');
	newWindow && newWindow.focus();
	trackDownloadsAsProperty(props.company.displayName, trackingKey, options);
	trackDownloadedProduct(trackingKey, options);
};

export const getAddonDataForDownload = (plan_or_addonid, version) => {
	const productKey = plan_or_addonid.split(plan_or_addonid.indexOf('_') !== -1 ? '_' : '-')[0].toUpperCase();
	
	const productVersion = parseInt(plan_or_addonid.split('_')[1]);
	const addonData = _.clone(DESKTOP_APPS[productKey]);
	addonData.downloadUrl = addonData.downloadUrl.replace('_VERSION_', version || productVersion);
	addonData.title = addonData.title.replace('_VERSION_', version || productVersion);
	addonData.itemKey = `${productKey}-${version || productVersion}`;
	addonData.productVersion = productVersion;
	addonData.productKey = productKey;

	return addonData;
};


// WEBPACK FOOTER //
// ./src/utils/downloads.js